
import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({ name: 'translateOfferType' })
export class TranslateOfferType implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(roleName: string) {
    return this.translate.instant(`OfferType.${roleName}`)
  }
}

